<div class="m-table">
  @if (loading) {
    <m-skeleton width="100%" height="40vh"></m-skeleton>
  } @else {
    <p-table
      #table
      [columns]="
        user && user.isSuperUser(selectionService)
          ? ['Client ID', 'Brand ID', 'Brand']
          : ['Brand']
      "
      selectionMode="single"
      [scrollable]="true"
      scrollHeight="40vh"
      sortField="Brand"
      [customSort]="true"
      (sortFunction)="customSort($event)"
      [value]="rows | async | sortBy: true : 'asc' : 'name'"
      [globalFilterFields]="['clientId', 'brandId', 'name']"
      [stripedRows]="true"
      styleClass="px-8">
      <ng-template pTemplate="caption">
        <div class="flex justify-end mb-4">
          <m-input-search
            placeholder="Search"
            [(ngModel)]="searchValue"
            (ngModelChange)="table.filterGlobal($event, 'contains')">
          </m-input-search>
        </div>
      </ng-template>
      <ng-template
        *ngIf="user && user.isSuperUser(selectionService)"
        pTemplate="header"
        let-cols>
        <tr>
          <th *ngFor="let col of cols" [pSortableColumn]="col" scope="col">
            {{ col }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-cols="columns">
        <tr [pSelectableRow]="rowData" (click)="switchBrand(rowData, user)">
          <td *ngFor="let col of cols">
            <ng-container *ngIf="col === 'Client ID'">
              {{ rowData.clientId }}
            </ng-container>
            <ng-container *ngIf="col === 'Brand ID'">
              {{ rowData.brandId }}
            </ng-container>
            <ng-container *ngIf="col === 'Brand'">
              {{ rowData.name }}
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
